import { render, staticRenderFns } from "./LicenciaAlcoholesRevision.vue?vue&type=template&id=59117382&"
import script from "./LicenciaAlcoholesRevision.vue?vue&type=script&lang=js&"
export * from "./LicenciaAlcoholesRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports